module.exports = __webpack_public_path__ + "static/media/canada-flag.0373c141.png";